import { useState, useEffect, useCallback } from "react";

import "../common/Util.css";
import { ReactComponent as SearchIc } from "../../assets/svg/search.svg";
import { ReactComponent as AddIc } from "../../assets/svg/add_icon.svg";
import { ReactComponent as DownArrowIc } from "../../assets/svg/down_arrow_ics.svg";
import { ReactComponent as RarIc } from "../../assets/svg/rar_ic.svg";
import { ReactComponent as LarIc } from "../../assets/svg/lar_ic.svg";
import { Button, Dropdown, Form, Toast, ToastContainer } from "react-bootstrap";
import SearchableDropdown from "../common/commonDropDown";
import ReactPaginate from "react-paginate";

import LoaderModal from "../common/loader";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../common/deleteModel";
import DateRangePicker from "../common/dateRange";
import "react-datepicker/dist/react-datepicker.css";

import { format } from "date-fns";
import { getProductListApi, deleteProductApi } from "./product-api";
import { useGlobal } from "../../GlobalContext";
import editIcon from "../../assets/svg/edit_ic.svg";
import deleteIcon from "../../assets/svg/delete_ic.svg";
import moreIcon from "../../assets/svg/more_ic.svg";
import Sidebar from "../common/Sidebar";
import productIcon from "../../assets/svg/milestone_active.svg"; // replace with product icon if available
import { ReactComponent as EmailView } from "../../assets/svg/email_view_ic.svg";
import { ReactComponent as ListView } from "../../assets/svg/list_view_ic.svg";
import { ReactComponent as SelectGrid } from "../../assets/svg/seelct_grid_ic.svg";
import { ReactComponent as SelectList } from "../../assets/svg/select_list_ic.svg";
import { FiChevronDown, FiFilter, FiPlus, FiSearch } from "react-icons/fi";
import { Navbar } from "../common/Navbar";

export const ProductListing = () => {
  const { rolePermissionList, userType } = useGlobal();
  function checkPermission(permission) {
    return rolePermissionList.findIndex((element) => element["name"] === "Product" && element["menu_permission"] === true && element[permission] === true) > -1 ? true : false;
  }

  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;

  const iconStyle = { width: "16px", height: "16px" };
  const [search, setSearch] = useState("");
  const [selectedSortby, setSelectedSortBy] = useState({
    value: "created desc",
    label: "Created (Newest)",
  });
  const [statusList, setStatusList] = useState([
    { value: "", label: "All" },
    { value: true, label: "Active" },
    { value: false, label: "InActive" },
  ]);
  const [selectedStatus, setSelectedStatus] = useState("");

  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [active, setActive] = useState("list");
  const [pageCount, setPageCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [deleteId, setDeleteId] = useState(null);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [productsList, setProductsList] = useState([]);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [statusSelect, setStatusSelect] = useState(null);
  const [startDateSave, setStartDateSave] = useState(null);
  const [endDateSave, setEndDateSave] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const sortByOption = [
    { value: "created asc", label: "Created (Oldest)" },
    { value: "created desc", label: "Created (Newest)" },
    { value: "name asc", label: "Name (A - Z)" },
    { value: "name desc", label: "Name (Z - A)" },
  ];

  const handleDateChange = ({ start, end }) => {
    setStartDate(start);
    setEndDate(end);
    const formattedStart = start ? format(start, "yyyy-MM-dd") : null;
    const formattedEnd = end ? format(end, "yyyy-MM-dd") : null;
    setStartDateSave(formattedStart);
    setEndDateSave(formattedEnd);
  };

  const handlePageClick = useCallback((event) => {
    setItemOffset(event.selected);
  }, []);

  useEffect(() => {
    getProductsList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemsPerPage, itemOffset, search, selectedSortby, statusSelect, startDateSave, endDateSave, selectedStatus]);

  const getProductsList = async () => {
    setIsLoading(true);
    const [field, dir] = selectedSortby?.value?.split(" ") || ["created", "desc"];
    const param = {
      limit: itemsPerPage,
      skip: itemOffset * itemsPerPage,
      search: search,
      status: selectedStatus ?? "",
      from_date: startDateSave,
      to_date: endDateSave,
      sort_field: field,
      sort_dir: dir,
      //   status: selectedStatus,
    };
    try {
      const response = await getProductListApi(param);
      console.log("reponse", response);
      if (response.data.success === true) {
        setTotalCount(response.data.totalCount ?? 0);
        setPageCount(response.data.totalPages ?? 0);
        setProductsList(response.data.products ?? []);
      }
    } catch (err) {
      console.error("Error fetching products:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const [isOpenDelete, setIsOpenDelete] = useState(false);
  useEffect(() => {
    if (deleteId !== null) {
      setIsOpenDelete(true);
    }
  }, [deleteId]);

  const deleteProduct = async () => {
    try {
      const response = await deleteProductApi(deleteId);
      if (response.data.success === true) {
        getProductsList();
        setDeleteId(null);
        setIsOpenDelete(false);
      }
      if (response.data) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        setShowSnackbar(true);
      }
    } catch (err) {
      console.error("Error deleting product:", err);
    } finally {
      setIsLoading(false);
    }
  };
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  return (
    <>
      <LoaderModal show={isLoading} />
      <DeleteModal
        title={"product"}
        isOpen={isOpenDelete}
        onClose={() => {
          setIsOpenDelete(false);
          setDeleteId(null);
        }}
        onDelete={deleteProduct}
      />
      <div className="d-flex">
        <Sidebar currentfile="Product" />
        <div className="rounded-4 flex-grow-1" style={{ width: "calc(100vw - 80px)" }}>
          <Navbar pageTitle="Product" />
          <div className="bg-half-white p-2">
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-4 mt-4">
              <div className="d-flex align-items-center gap-3">
                <h5 className="fs-14 fw-600 text-secondary m-0" style={{ color: "#9299A7" }}>
                  PRODUCTS : {totalCount}
                </h5>

                <div className="d-flex align-items-center gap-2 ">
                  <Dropdown>
                    <Dropdown.Toggle variant="light" size="sm" className="fs-13 fw-500 py-1 px-3 d-flex align-items-center justify-content-between bg-white border rounded" style={{ color: "#495057" }}>
                      Status:
                      {statusList.find((s) => s.value === selectedStatus)?.label}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      {statusList.map((item, index) => (
                        <Dropdown.Item key={index} onClick={() => setSelectedStatus(item.value)}>
                          {item.label}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>

                  <span
                    className="text-muted text-decoration-underline fs-14 fw-400"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setSelectedStatus("");
                      setSearch("");
                      setStartDateSave(null);
                      setEndDateSave(null);
                      setStartDate(null);
                      setEndDate(null);
                      setSelectedSortBy({
                        value: "created desc",
                        label: "Created (Newest)",
                      });
                    }}
                  >
                    Reset Filters
                  </span>
                </div>
              </div>

              <div className="d-flex align-items-center gap-2 flex-wrap">
                <div className="position-relative">
                  <FiSearch
                    className="position-absolute text-muted"
                    style={{
                      left: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      zIndex: 1,
                    }}
                  />
                  <Form.Control
                    type="text"
                    placeholder=""
                    className="border bg-white"
                    onChange={(e) => setSearch(e.target.value)}
                    style={{
                      height: "32px",
                      paddingLeft: "30px",
                      borderRadius: "20px",
                      width: isSearchFocused ? "180px" : "40px",
                      transition: "width 0.3s",
                      cursor: isSearchFocused ? "text" : "pointer",
                    }}
                    onFocus={() => setIsSearchFocused(true)}
                    onBlur={() => setIsSearchFocused(false)}
                  />
                </div>

                {checkPermission("create_permission") && (
                  <div
                    className=" fs-13 fw-700 d-flex align-items-center gap-2 rounded"
                    style={{
                      padding: "5px 12px",
                      backgroundColor: "#3469E7",
                      borderColor: "#3469E7",
                      color: "#FFFFFF",
                      cursor: "pointer",
                    }}
                    onClick={() => navigate("/product/create")}
                  >
                    <FiPlus /> Add Product
                  </div>
                )}

                <div
                  className="d-flex align-items-center px-1"
                  style={{
                    borderRadius: "8px",
                    maxWidth: "200px",
                    height: "32px",
                    border: "1px solid #EBEBEB",
                    backgroundColor: "white",
                  }}
                >
                  <span className="fs-12 fw-400 textGrey">Date :</span>
                  <div className="dropdown-text1 ms-2" style={{ marginBottom: "4px" }}>
                    <DateRangePicker onChange={handleDateChange} startDate={startDate} endDate={endDate} />
                  </div>
                </div>

                <div onClick={(e) => e.stopPropagation()}>
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="light"
                      id="dropdown-sort"
                      className="d-flex align-items-center justify-content-between"
                      style={{
                        borderRadius: "8px",
                        border: "1px solid #EBEBEB",
                        padding: "6px 12px",
                        backgroundColor: "white",
                      }}
                      title={selectedSortby.label}
                    >
                      <span className="fs-12 fw-400 textGrey">Sort by :</span>
                      <span className="d-flex align-items-center px-1">
                        <span className="dropdown-text">{selectedSortby.label}</span>
                      </span>
                    </Dropdown.Toggle>

                    <Dropdown.Menu
                      style={{
                        backgroundColor: "white",
                        borderRadius: "8px",
                        border: "1px solid #EBEBEB",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      {sortByOption.map((option) => (
                        <Dropdown.Item
                          className="fs-14 fw-500 textcolor"
                          key={option.value}
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedSortBy(option);
                          }}
                          active={selectedSortby === option.value}
                        >
                          {option.label}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>

                <div
                  className="rounded-3 toggleBg d-flex"
                  style={{
                    width: "80px",
                    height: "32px",
                    backgroundColor: "#FFFFFF",
                    padding: "4px",
                    gap: "4px",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "1px solid #EBEBEB",
                  }}
                >
                  <div onClick={() => setActive("list")} className={`d-flex align-items-center justify-content-center rounded-3 ${active === "list" ? "bg-primary1" : ""}`} style={{ width: "36px", height: "24px", cursor: "pointer" }}>
                    {active === "list" ? <ListView style={iconStyle} /> : <SelectList style={iconStyle} />}
                  </div>

                  <div onClick={() => setActive("grid")} className={`d-flex align-items-center justify-content-center rounded-3 ${active === "grid" ? "bg-primary1" : ""}`} style={{ width: "36px", height: "24px", cursor: "pointer" }}>
                    {active === "grid" ? <SelectGrid style={iconStyle} /> : <EmailView style={iconStyle} />}
                  </div>
                </div>
              </div>
            </div>

            {active === "list" && (
              <div className="w-100 trip-table-wrapper bg-white rounded-4 w-100">
                <div
                  style={{
                    display: "flex",
                    flex: "7",
                    paddingLeft: "16px",
                    paddingRight: "16px",
                    height: "50px",
                    backgroundColor: "#FFFFFF",
                    border: "1px solid #e5e5e5",
                  }}
                  className="head3 w-100 justify-content-start align-items-center"
                >
                  <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor text-start table-header-p">
                    PRODUCT ID
                  </p>
                  <p style={{ flex: "2" }} className="fs-13 fw-700 textcolor text-start table-header-p">
                    NAME
                  </p>
                  <p style={{ flex: "1", height: "50px" }} className="fs-13 fw-700 textcolor text-start table-header-p">
                    WEIGHT
                  </p>
                  <div
                    style={{
                      flex: "2",
                      display: "flex",
                      flexDirection: "column",
                      height: "100%",
                      borderLeft: "1px solid #e5e5e5",
                      borderRight: "1px solid #e5e5e5",
                    }}
                  >
                    <div
                      style={{
                        flex: 1,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderBottom: "1px solid #e5e5e5",
                        height: "50px",
                      }}
                      className="fs-13 fw-700 textcolor"
                    >
                      DIMENSION
                    </div>
                    <div style={{ flex: 1, display: "flex" }}>
                      <div
                        style={{
                          flex: 1,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRight: "1px solid #e5e5e5",
                        }}
                        className="fs-12 fw-700 textcolor"
                      >
                        L
                      </div>
                      <div
                        style={{
                          flex: 1,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRight: "1px solid #e5e5e5",
                        }}
                        className="fs-12 fw-700 textcolor"
                      >
                        B
                      </div>
                      <div
                        style={{
                          flex: 1,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        className="fs-12 fw-700 textcolor"
                      >
                        H
                      </div>
                    </div>
                  </div>
                  <p style={{ flex: "1", paddingLeft: "10px" }} className="fs-13 fw-700 textcolor text-start table-header-p">
                    CRITERIA
                  </p>
                  <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor text-start table-header-p">
                    STATUS
                  </p>
                </div>
                <div>
                  {(productsList ?? []).map((item, index) => (
                    <div
                      key={item.id ?? index}
                      style={{
                        display: "flex",
                        flex: "10",
                        paddingLeft: "16px",
                        paddingRight: "16px",
                        backgroundColor: hoveredIndex === index ? "#FAFAFA" : "#FFFFFF",
                        borderBottom: "1px solid #D4DDE7",
                        borderLeft: "1px solid #D4DDE7",
                        borderRight: "1px solid #D4DDE7",
                        cursor: "pointer",
                        height: "44px",
                      }}
                      onClick={() => {
                        if (checkPermission("view_permission")) {
                          navigate("/product/view", {
                            state: { id: item.id },
                          });
                        }
                      }}
                      onMouseEnter={() => setHoveredIndex(index)}
                      onMouseLeave={() => setHoveredIndex(null)}
                      className="head3 w-100 justify-content-center align-items-center"
                    >
                      <p
                        className="fs-13 fw-500 textcolor text-start table-row-p"
                        style={{
                          flex: "1",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          marginTop: "16px",
                        }}
                        title={item.item_code ?? "-"}
                      >
                        {item.item_code ?? "---"}
                      </p>

                      <p
                        className="fs-13 fw-500 textcolor text-start table-row-p"
                        style={{
                          flex: "2",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          marginTop: "16px",
                        }}
                        title={item.item_name}
                      >
                        {item.item_name ?? "---"}
                      </p>

                      <p
                        className="fs-13 fw-500 textcolor text-start table-row-p"
                        style={{
                          flex: "1",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          marginTop: "16px",
                        }}
                        title={item.weitght}
                      >
                        {item.weight ?? "-"}
                      </p>

                      <div
                        style={{
                          flex: "2",
                          display: "flex",
                          height: "100%",
                          borderLeft: "1px solid #D4DDE7",
                          borderRight: "1px solid #D4DDE7",
                        }}
                        title={`${item.length ?? "-"} x ${item.width ?? "-"} x ${item.height ?? "-"}`}
                      >
                        <div
                          style={{
                            flex: 1,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRight: "1px solid #D4DDE7",
                          }}
                          className="fs-13 fw-500 textcolor"
                        >
                          {item.length ?? "-"} {item.length > 0 && item.dimension ? `(${item.dimension})` : ""}
                        </div>
                        <div
                          style={{
                            flex: 1,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRight: "1px solid #D4DDE7",
                          }}
                          className="fs-13 fw-500 textcolor"
                        >
                          {item.width ?? "-"}
                          {item.width > 0 && item.dimension ? `(${item.dimension})` : ""}
                        </div>
                        <div
                          style={{
                            flex: 1,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          className="fs-13 fw-500 textcolor"
                        >
                          {item.height ?? "-"}
                          {item.height > 0 && item.dimension ? `(${item.dimension})` : ""}
                        </div>
                      </div>

                      <p
                        className="fs-13 fw-500 textcolor text-start table-row-p"
                        style={{
                          flex: "1",
                          paddingLeft: "10px",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          marginTop: "16px",
                        }}
                        title={item.criteria}
                      >
                        {item.criteria ?? "--"}
                      </p>

                      <p
                        className="fs-13 fw-500 textcolor text-start table-row-p"
                        style={{
                          flex: "1",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          marginTop: "16px",
                        }}
                        title={item.status}
                      >
                        <span
                          className="d-inline-block rounded"
                          style={{
                            backgroundColor: item.status ? "#D4F7D4" : "#FFE9D5",
                            color: item.status ? "#0F9D0F" : "#F57600",
                            padding: "6px 16px",
                            fontSize: "11px",
                            minWidth: "80px",
                          }}
                        >
                          {item.status ? "ACTIVE" : "INACTIVE"}
                        </span>
                      </p>

                      {hoveredIndex === index && (
                        <div
                          style={{
                            position: "absolute",
                            right: "35px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "start",
                              alignItems: "center",
                            }}
                          >
                            {checkPermission("edit_permission") && (
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigate("/product/create", {
                                    state: { id: item.id },
                                  });
                                }}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "28px",
                                  height: "28px",
                                  borderRadius: "100px",
                                  background: "#FFFFFF",
                                  cursor: "pointer",
                                  border: "0.8px solid #E5E5E5",
                                }}
                              >
                                <img src={editIcon} alt="edit" />
                              </div>
                            )}
                            <span style={{ marginLeft: "16px" }}></span>
                            {checkPermission("delete_permission") && (
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setDeleteId(item.id);
                                }}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "28px",
                                  height: "28px",
                                  borderRadius: "100px",
                                  background: "#FFFFFF",
                                  cursor: "pointer",
                                  border: "0.8px solid #E5E5E5",
                                }}
                              >
                                <img src={deleteIcon} alt="delete" />
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}

            {active === "grid" &&
              productsList.map((item, index) => (
                <div
                  key={item.id ?? index}
                  className="bg-white rounded-4 d-flex flex-wrap align-items-center justify-content-between business-card w-100 p-3 mb-3"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    if (checkPermission("view_permission")) {
                      navigate("/product/view", {
                        state: { id: item.id },
                      });
                    }
                  }}
                >
                  <div className="col-12 col-md-6 col-lg-3 d-flex flex-grow-1 me-2" style={{ borderRight: "1px solid #EBEBEB" }}>
                    <div className="profile-wrapper" style={{ background: "#F4F4F4" }}>
                      <img key={index} src={productIcon} alt="product" className="profile-img" />
                    </div>
                    <div className="d-flex flex-column justify-content-center align-items-start gap-1 ps-3">
                      <div className="textFontColor fs-16 fw-600">{item.item_name ?? "-"}</div>
                      <div className="d-flex gap-2 align-items-center">
                        <span className="text-gray fs-12 fw-500">{item.item_code ?? ""}</span>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-6 col-lg-3 ms-3 d-flex flex-column flex-grow-1 align-items-start justify-content-start me-1" style={{ borderRight: "1px solid #EBEBEB" }}>
                    <div className="d-flex flex-column flex-grow-1 align-items-start">
                      <div className="fs-12 fw-600 cardTextGrey">
                        WEIGHT : <span className="fs-14 fw-400 textcolor">{item.weight ?? "-"}</span>
                      </div>
                      <div className="fs-12 fw-600 cardTextGrey mt-1">
                        DIMENSION : <span className="fs-14 fw-400 textcolor">{item.length != null || item.width != null || item.height != null ? `${item.length ?? "-"} x ${item.width ?? "-"} x ${item.height ?? "-"}` : item.dimension ?? "-"}</span>
                      </div>
                    </div>
                  </div>

                  <div className="d-flex flex-row flex-grow-1 align-items-end justify-content-end gap-2 ps-3">
                    <div onClick={(e) => e.stopPropagation()}>
                      {(checkPermission("edit_permission") || checkPermission("delete_permission")) && (
                        <Dropdown>
                          <Dropdown.Toggle
                            bsPrefix="custom-toggle"
                            variant="light"
                            id="dropdown-sort"
                            className="d-flex align-items-center justify-content-between rounded-5 bg-white"
                            style={{
                              width: "36px",
                              height: "36px",
                              border: "1px solid #EBEBEB",
                            }}
                          >
                            <span className="d-flex align-items-center px-1 gap-2">
                              <img src={moreIcon} alt="more" />
                            </span>
                          </Dropdown.Toggle>

                          <Dropdown.Menu
                            style={{
                              backgroundColor: "white",
                              borderRadius: "8px",
                              border: "1px solid #EBEBEB",
                              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            }}
                          >
                            {checkPermission("edit_permission") && (
                              <Dropdown.Item
                                className="fs-14 fw-500 textcolor"
                                onClick={() => {
                                  navigate("/product/create", {
                                    state: { id: item.id },
                                  });
                                }}
                              >
                                Edit
                              </Dropdown.Item>
                            )}
                            {checkPermission("delete_permission") && (
                              <Dropdown.Item
                                className="fs-14 fw-500 textcolor"
                                onClick={() => {
                                  setDeleteId(item.id);
                                }}
                              >
                                Delete
                              </Dropdown.Item>
                            )}
                          </Dropdown.Menu>
                        </Dropdown>
                      )}
                    </div>
                  </div>
                </div>
              ))}

            <div className="py-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
              <Dropdown>
                <span className="pagination-color">Records per page: &nbsp;</span>
                <Dropdown.Toggle id="dropdown-basic" className="bg-transparent pagination-color border-0 custom-dropdown-toggle p-0">
                  <span className="bg-white textcolor no-of-rows rounded-3 px-2 py-2">
                    {itemsPerPage} <DownArrowIc />
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu className="my-2" style={{ minWidth: "unset", width: "30%" }}>
                  {[10, 25, 50, 75, 100].map((size) => (
                    <Dropdown.Item
                      key={size}
                      onClick={() => {
                        setItemsPerPage(size);
                      }}
                      active={itemsPerPage === size}
                      className="text-center"
                    >
                      {size}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>

              <div className="d-flex align-items-center gap-2">
                <ReactPaginate
                  previousLabel={
                    <div
                      className="rounded-5 bg-white d-flex align-items-center justify-content-center"
                      style={{
                        width: "32px",
                        height: "32px",
                      }}
                    >
                      <LarIc />
                    </div>
                  }
                  nextLabel={
                    <div
                      className="rounded-5 bg-white d-flex align-items-center justify-content-center"
                      style={{
                        width: "32px",
                        height: "32px",
                      }}
                    >
                      <RarIc />
                    </div>
                  }
                  breakLabel={"..."}
                  pageCount={pageCount + 1}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer position="top-end">
        <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={() => setShowSnackbar(false)} delay={3000} autohide>
          <Toast.Body style={{ color: "#ffffff" }}>{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
};

export default ProductListing;
